interface IProps {
    children?: any,
}

export const SectionsTable = (props: IProps) => {
    return (
        <div className="table-responsive">
            <table className="table table-centered">
                <thead className="thead-light">
                    <tr>
                        <th>Název</th>

                        <th>Cesta v url</th>

                        <th>Počet stránek</th>
  
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    {props.children}
                </tbody>
            </table>
        </div>)
}